export const BannerTypes = ["info", "success", "warning", "error"];
